import React from "react";
import Billings from "../../pages/Billings";

type Props = {};

const BillingSetting = (props: Props) => {
  return (
    <Billings />
  );
};

export default BillingSetting;
